import React, { useState } from "react";
import { InputAdornment, TextField, makeStyles } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { useTranslation } from "react-i18next";
import { useAsyncDebounce } from "react-table";
import { BORDER_RADIUS_FIELDS } from "../../../customSimpleFields/styles/SharedStyles";

export const useStyles = makeStyles((theme) => ({
  searchContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: 250,
    [theme.breakpoints.between("xs")]: {
      width: 150,
    },
  },
  searchInput: {
    fontSize: "1.1rem",
    border: "0",
    width: "100%",
  },
  searchResultsLabel: {
    color: "grey",
    fontStyle: "italic",
    padding: "0px 0px 0px 10px",
  },
  focusedV2: {
    backgroundColor: `${theme.palette.content.mainColor}22`,
    border: `2px solid ${theme.palette.content.mainColor}AA !important`,
  },
  rootV2: {
    border: "1px solid #aca4a4",
    padding: "1px 6px",
    borderRadius: `${BORDER_RADIUS_FIELDS}px !important`,
    height: 30,
  },
}));

export default function GlobalSearchFilterInput(props) {
  const { globalFilter, setGlobalFilter, rows, count, isDisabled } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [value, setValue] = useState(globalFilter);

  const handleChangeGlobalFilterInput = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  // TODO: dinamico
  const isV2Styles = true;

  return (
    <div className={classes.searchContainer}>
      <TextField
        disabled={isDisabled === true}
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          handleChangeGlobalFilterInput(e.target.value);
        }}
        placeholder={`${count} ${t("FORM_TABLE_SEARCH_TEXT")}`}
        className={classes.searchInput}
        classes={
          isV2Styles
            ? {
                root: classes.rootV2,
                focused: classes.focusedV2,
              }
            : undefined
        }
        InputProps={{
          disableUnderline: true,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon style={{ color: "grey" }} />
            </InputAdornment>
          ),
        }}
      />

      {rows && rows.length !== count && (
        <label className={classes.searchResultsLabel}>
          ({rows.length}) {t("FORM_TABLE_SEARCH_TEXT_RESULT")}
        </label>
      )}
    </div>
  );
}
